import React from "react";
import "./Synonyms.css";

export default function Synonyms(props) {
    if(props.synonyms.length > 0) {
        return (
            <div className="Synonyms">
                {props.synonyms.map(function (synonym, index) {
                    return <span className="badge rounded-pill" key={index}>{synonym}</span>
                })}
            </div>
        );
    } else {
        return null;
    }    
}